/*!
 * Copyright (c) 2018-present Cyclope.ai
 * LICENSE file is in the root directory of this source tree.
 * */

/**
 * Enum pour la mise à jour de l'utilisateur
 * @readonly
 * @enum { string }
 */

export enum UsersUpdatedActionTypes {

  /** @type {string} */

  USERSUPDATED_SUCCESS =
      '[Tunnel Watch] La mise à jour de l\'utilisateur a réussi ...',
  USERSUPDATED_FAIL =
      '[Tunnel Watch] La mise à jour de l\'utilisateur a échoué ...',
  USERSUPDATED_INPROGRESS =
      '[Tunnel Watch] La mise à jour de l\'utilisateur est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================


/**
 * Enum pour la suppression d'un utilisateur
 * @readonly
 * @enum { string }
 */

export enum UsersRemovedActionTypes {

  /** @type {string} */

  USERSREMOVED_SUCCESS =
      '[Tunnel Watch] La suppression de  l\'utilisateur a réussi ...',
  USERSREMOVED_FAIL =
      '[Tunnel Watch] La suppression de  l\'utilisateur a échoué ...',
  USERSREMOVED_INPROGRESS =
      '[Tunnel Watch] La suppression de  l\'utilisateur est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour la création des utilisateurs
 * @readonly
 * @enum { string }
 */

export enum UsersCreatedActionTypes {

  /** @type {string} */

  USERSCREATED_SUCCESS =
      '[Tunnel Watch] La création des utilisateurs a réussi ...',
  USERSCREATED_FAIL =
      '[Tunnel Watch] La création des utilisateurs a échoué ...',
  USERSCREATED_INPROGRESS =
      '[Tunnel Watch] La création des utilisateurs est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour les utilisateurs
 * @readonly
 * @enum { string }
 */

export enum UsersLoadedActionTypes {

  /** @type {string} */

  USERSLOADED_SUCCESS =
      '[Tunnel Watch] Le chargement des utilisateurs a réussi ...',
  USERSLOADED_FAIL =
      '[Tunnel Watch] Le chargement des utilisateurs a échoué ...',
  USERSLOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement des utilisateurs est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================
/**
 * Enum pour l'authentification
 * @readonly
 * @enum { string }
 */

export enum LoginActionTypes {

  /** @type {string} */

  LOGIN_SUCCESS = '[Tunnel Watch] L\'autentification a réussi ...',
  LOGIN_FAIL = '[Tunnel Watch] L\'autentification a échoué ...',
  LOGIN_INPROGRESS = '[Tunnel Watch] L\'autentification est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================
/**
 * Enum pour la vérification d'une nouvelle incident
 * @readonly
 * @enum { string }
 */

export enum CheckNewIncidentsActionTypes {

  /** @type {string} */

  CHECKNEWINCIDENTS_SUCCESS =
      'La vérification de nouvelles incidents a réussi ...',
  CHECKNEWINCIDENTS_FAIL =
      'La vérification de nouvelles incidents a échoué ...',
  CHECKNEWINCIDENTS_INPROGRESS =
      'La vérification de nouvelles incidents est en cours ...',

}

/**
 * Enum pour la vérification d'une nouvelle incident
 * @readonly
 * @enum { string }
 */

export enum CheckIncidentsIsNotQualifyActionTypes {

  /** @type {string} */

  CHECKINCIDENTSISNOTQUALIFY_SUCCESS =
      'vérification d\'incident non qualifier incidents a réussi ...',
  CHECKINCIDENTSISNOTQUALIFY_FAIL =
      'vérification d\'incident non qualifier incidents a échoué ...',
  CHECKINCIDENTSISNOTQUALIFY_INPROGRESS =
      'vérification d\'incident non qualifier incidents est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================


/**
 * Enum pour le changement de mot de passe
 * @readonly
 * @enum { string }
 */

export enum ChangePassWordActionTypes {
  /** @type {string} */

  CHANGEPASSWORD_SUCCESS =
      '[Tunnel Watch] Le changement de votre mot de passe a réussi ...',
  CHANGEPASSWORD_FAIL =
      '[Tunnel Watch] Le changement de votre mot de passe a échoué ...',
  CHANGEPASSWORD_INPROGRESS =
      '[Tunnel Watch] Le changement de votre mot de passe est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour l'initialisation du store
 * @readonly
 * @enum { string }
 */

export enum ResetActionTypes {
  /** @type {string} */
  RESET_SUCCESS = '[Tunnel Watch] L\' initialisation du store a réussi...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour la deconnexion au site
 * @readonly
 * @enum { string }
 */

export enum LogoutActionTypes {

  /** @type {string} */

  LOGOUT_SUCCESS = '[Tunnel Watch] La déconnexion a réussi ...',
  LOGOUT_FAIL = '[Tunnel Watch] La déconnexion a échoué ...',
  LOGOUT_INPROGRESS = '[Tunnel Watch] La déconnexion est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour la notification des incidents
 * @readonly
 * @enum { string }
 */

export enum NotificationLoadedActionTypes {

  /** @type {string} */

  NOTIFICATIONLOADED_SUCCESS =
      '[Tunnel Watch] Le chargement des notifications des incidents  a réussi ...',
  NOTIFICATIONLOADED_FAIL =
      '[Tunnel Watch] Le chargement des notifications des incidents a échoué ...',
  NOTIFICATIONLOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement des notifications des incidents est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour le paramétrage des incidents
 * @readonly
 * @enum { string }
 */

export enum ImpactSettingActionTypes {

  /** @type {string} */

  IMPACTSETTING_SUCCESS =
      '[Tunnel Watch] Le chargement des paramètres d\'incidents a réussi ...',
  IMPACTSETTING_FAIL =
      '[Tunnel Watch] Le chargement des paramètres d\'incidents a échoué ...',
  IMPACTSETTING_INPROGRESS =
      '[Tunnel Watch] Le chargement des paramètres d\'incidents est en cours ...',

}
// ==============================================================================================================

/**
 * Enum pour le paramétrage des incidents
 * @readonly
 * @enum { string }
 */

export enum DisplayParamVideoActionTypes {

  /** @type {string} */

  DISPLAYPARAMVIDEO_SUCCESS =
      '[Tunnel Watch] Mise à jour des paramètres d\'extraction de la vidéo a réussi ...',
  DISPLAYPARAMVIDEO_FAIL =
      '[Tunnel Watch] Mise à jour des paramètres d\'extraction de la vidéo a échoué ...',
  DISPLAYPARAMVIDEO_INPROGRESS =
      '[Tunnel Watch] Mise à jour des paramètres d\'extraction de la vidéo est en cours ...',

}

/**
 * Enum pour le paramétrage des incidents
 * @readonly
 * @enum { string }
 */

export enum DisplayParamVideoLoadedActionTypes {

  /** @type {string} */

  DISPLAYPARAMVIDEOLOADED_SUCCESS =
      '[Tunnel Watch] Le chargement des paramètres d\'extraction de la vidéo a réussi ...',
  DISPLAYPARAMVIDEOLOADED_FAIL =
      '[Tunnel Watch] Le chargement des paramètres d\'extraction de la vidéo a échoué ...',
  DISPLAYPARAMVIDEOLOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement des paramètres d\'extraction de la vidéo est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour la création des inhibition globale
 * @readonly
 * @enum { string }
 */

export enum IncidentInhibateActionTypes {

  /** @type {string} */

  INCIDENTINHIBATE_SUCCESS =
      '[Tunnel Watch] L\'inhibition d\'incidents a réussi ...',
  INCIDENTINHIBATE_FAIL =
      '[Tunnel Watch] L\'inhibition d\'incidents a échoué ...',
  INCIDENTINHIBATE_INPROGRESS =
      '[Tunnel Watch] L\'inhibition d\'incidents est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour l'insertion' des règles d'affichage des incidents
 * @readonly
 * @enum { string }
 */
export enum IncidentRulesActionTypes {

  /** @type {string} */

  INCIDENTRULES_SUCCESS =
      '[Tunnel Watch] L\'insertion des règles dans les paramètres d\'incidents a réussi ...',
  INCIDENTRULES_FAIL =
      '[Tunnel Watch] L\'insertion des règles dans les paramètres d\'incidents a échoué ...',
  INCIDENTRULES_INPROGRESS =
      '[Tunnel Watch] L\'insertion des règles dans les paramètres d\'incidents est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour la chargement des paramètre de la caméra
 * @readonly
 * @enum { string }
 */
export enum CameraSettingLoadedActionTypes {

  /** @type {string} */
  CAMERASETTINGLOADED_SUCCESS =
      '[Tunnel Watch] Le chargement des paramètres de la camera a réussi ...',
  CAMERASETTINGLOADED_FAIL =
      '[Tunnel Watch] Le chargement des paramètres de la camera a échoué ...',
  CAMERASETTINGLOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement des paramètres de la camera est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour la chargement des infos de tunnelwatch
 * @readonly
 * @enum { string }
 */
export enum VersionningActionTypes {

  /** @type {string} */
  VERSIONNING_SUCCESS =
      '[Tunnel Watch] Le chargement de la version de tunnelwatch a réussi ...',
  VERSIONNING_FAIL =
      '[Tunnel Watch] Le chargement de la version de tunnelwatch a échoué ...',
  VERSIONNING_INPROGRESS =
      '[Tunnel Watch] Le chargement de la version de tunnelwatch est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour l'envoie du mail de recupération du mot de passe
 * @readonly
 * @enum { string }
 */

export enum EmailForgetPassWordActionTypes {

  /** @type {string} */
  EMAILFORGETPASSWORD_SUCCESS =
      '[Tunnel Watch] L\' envoie du mail a réussi ...',
  EMAILFORGETPASSWORD_FAIL = '[Tunnel Watch] L\' envoie du mail a échoué ...',
  EMAILFORGETPASSWORD_INPROGRESS =
      '[Tunnel Watch] L\' envoie du mail est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour l'initialisation du mot de passe
 * @readonly
 * @enum { string }
 */
export enum NewPassWordActionTypes {

  /** @type {string} */
  NEWPASSWORD_SUCCESS =
      '[Tunnel Watch] La création du nouveau mot de passe a réussi ...',
  NEWPASSWORD_FAIL =
      '[Tunnel Watch] La création du nouveau mot de passe a échoué ...',
  NEWPASSWORD_INPROGRESS =
      '[Tunnel Watch] La création du nouveau mot de passe est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour la mise à jour du masque de la camera
 * @readonly
 * @enum { string }
 */
export enum CameraUpdateZoneActionTypes {

  /** @type {string} */
  CAMERAUPDATEZONE_SUCCESS =
      '[Tunnel Watch] La mise à jour du masque de la camera a réussi ...',
  CAMERAUPDATEZONE_FAIL =
      '[Tunnel Watch] La mise à jour du masque de la camera a échoué ...',
  CAMERAUPDATEZONE_INPROGRESS =
      '[Tunnel Watch] La mise à jour du masque de la camera est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour La segmentation de la camera
 * @readonly
 * @enum { string }
 */

export enum CameraSwitchSegmentedActionTypes {

  /** @type {string} */
  CAMERASWITCHSEGMENTED_SUCCESS =
      '[Tunnel Watch] La segmentation de la camera a réussi ...',
  CAMERASWITCHSEGMENTED_FAIL =
      '[Tunnel Watch] La segmentation de la camera a échoué ...',
  CAMERASWITCHSEGMENTED_INPROGRESS =
      '[Tunnel Watch] La segmentation de la camera est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour La segmentation de la section
 * @readonly
 * @enum { string }
 */

export enum SectionSwitchSegmentedActionTypes {

  /** @type {string} */
  SECTIONSWITCHSEGMENTED_SUCCESS =
      '[Tunnel Watch] La segmentation de la section a réussi ...',
  SECTIONSWITCHSEGMENTED_FAIL =
      '[Tunnel Watch] La segmentation de la section a échoué ...',
  SECTIONSWITCHSEGMENTED_INPROGRESS =
      '[Tunnel Watch] La segmentation de la section est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour l'initialisation de la  segmentation
 * @readonly
 * @enum { string }
 */
export enum SectionSwitchSegmentedResetActionTypes {

  /** @type {string} */
  SECTIONSWITCHSEGMENTEDRESET_SUCCESS =
      '[Tunnel Watch] L\'initialisation de la  segmentation la section a réussi ...',
  SECTIONSWITCHSEGMENTEDRESET_FAIL =
      '[Tunnel Watch] L\'initialisation de la  segmentation la section a échoué ...',
  SECTIONSWITCHSEGMENTEDRESET_INPROGRESS =
      '[Tunnel Watch] L\'initialisation de la  segmentation la section est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================
/**
 * Enum pour l'initialisation de la  segmentation de la caméra
 * @readonly
 * @enum { string }
 */
export enum CameraSwitchSegmentedResetActionTypes {

  /** @type {string} */
  CAMERASWITCHSEGMENTEDRESET_SUCCESS =
      '[Tunnel Watch] L\'initialisation de la  segmentation de la caméra a réussi ...',
  CAMERASWITCHSEGMENTEDRESET_FAIL =
      '[Tunnel Watch] L\'initialisation de la  segmentation de la caméra a échoué ...',
  CAMERASWITCHSEGMENTEDRESET_INPROGRESS =
      '[Tunnel Watch] L\'initialisation de la  segmentation de la caméra est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================


/**
 * Enum pour la création des paramètres de la camera
 * @readonly
 * @enum { string }
 */

export enum CameraSettingActionTypes {

  /** @type {string} */
  CAMERASETTING_SUCCESS =
      '[Tunnel Watch] La création des paramètres de la camera a réussi ...',
  CAMERASETTING_FAIL =
      '[Tunnel Watch] La création des paramètres de la camera a échoué ...',
  CAMERASETTING_INPROGRESS =
      '[Tunnel Watch] La création des paramètres de la camera est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour le chargement des inhibitions de la camera
 * @readonly
 * @enum { string }
 */

export enum CameraInhibitionsLoadedActionTypes {

  /** @type {string} */
  CAMERAINHIBITIONSLOADED_SUCCESS =
      '[Tunnel Watch] Le chargement des inhibitions de la camera a réussi ...',
  CAMERAINHIBITIONSLOADED_FAIL =
      '[Tunnel Watch] Le chargement des inhibitions de la camera a échoué ...',
  CAMERAINHIBITIONSLOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement des inhibitions de la camera est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour le chargement des inhibitions
 * @readonly
 * @enum { string }
 */
export enum ModalInhibitionsLoadedActionTypes {

  /** @type {string} */
  MODALINHIBITIONSLOADED_SUCCESS =
      '[Tunnel Watch] Le chargement des inhibitions a réussi ...',
  MODALINHIBITIONSLOADED_FAIL =
      '[Tunnel Watch] Le chargement des inhibitions a échoué ...',
  MODALINHIBITIONSLOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement des inhibitions  est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour la mise à jour des inhibitions
 * @readonly
 * @enum { string }
 */

export enum ModalInhibitionsUpdatedActionTypes {

  /** @type {string} */
  MODALINHIBITIONSUPDATED_SUCCESS =
      '[Tunnel Watch] Mise à jour des inhibitions a réussi ...',
  MODALINHIBITIONSUPDATED_FAIL =
      '[Tunnel Watch] Mise à jour des inhibitions a échoué ...',
  MODALINHIBITIONSUPDATED_INPROGRESS =
      '[Tunnel Watch] Mise à jour des inhibitions  est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================


/**
 * Enum pour le chargement des types d'incident
 * @readonly
 * @enum { string }
 */
export enum IncidentTypesLoadedActionTypes {

  /** @type {string} */
  INCIDENTTYPESLOADED_SUCCESS =
      '[Tunnel Watch] Le chargement des types d\'incident a réussi ...',
  INCIDENTTYPESLOADED_FAIL =
      '[Tunnel Watch] Le chargement des types d\'incident a échoué ...',
  INCIDENTTYPESLOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement des types d\'incident est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================


/**
 * Enum pour la création d'une nouvelle caméra
 * @readonly
 * @enum { string }
 */

export enum CameraCreatedActionTypes {

  /** @type {string} */
  CAMERACREATED_SUCCESS =
      '[Tunnel Watch] La création d\'une nouvelle camera  a réussi ...',
  CAMERACREATED_FAIL =
      '[Tunnel Watch] La création d\'une nouvelle camera  a échoué ...',
  CAMERACREATED_INPROGRESS =
      '[Tunnel Watch] La création d\'une nouvelle camera  est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================


/**
 * Enum pour la suppression d'une caméra
 * @readonly
 * @enum { string }
 */

export enum CameraRemoveActionTypes {

  /** @type {string} */
  CAMERAREMOVE_SUCCESS =
      '[Tunnel Watch] La suppression de la camera  a réussi ...',
  CAMERAREMOVE_FAIL =
      '[Tunnel Watch] La suppression de la camera  a échoué ...',
  CAMERAREMOVE_INPROGRESS =
      '[Tunnel Watch] La suppression de la camera  est en cours ...',

}
/**
 * Enum pour la mise à jour de la camera
 * @readonly
 * @enum { string }
 */
export enum CameraUpdateActionTypes {

  /** @type {string} */
  CAMERAUPDATE_SUCCESS =
      '[Tunnel Watch] La mise à jour de la camera a réussi ...',
  CAMERAUPDATE_FAIL = '[Tunnel Watch] La mise à jour de la camera a échoué ...',
  CAMERAUPDATE_INPROGRESS =
      '[Tunnel Watch] La mise à jour de la camera est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour le chargement des cameras
 * @readonly
 * @enum { string }
 */
export enum CameraLoadedActionTypes {

  /** @type {string} */
  CAMERALOADED_SUCCESS =
      '[Tunnel Watch] Le chargement des cameras  a réussi ...',
  CAMERALOADED_FAIL = '[Tunnel Watch] Le chargement des cameras  a échoué ...',
  CAMERALOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement des cameras  est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour le chargement des caméras qui precèdent l'incident
 * @readonly
 * @enum { string }
 */

export enum GetCameraBeforeAndAfterByLocationActionTypes {

  /** @type {string} */
  GETCAMERABEFOREANDAFTERBYLOCATION_SUCCESS =
      '[Tunnel Watch] Le chargement des caméra qui precèdent l\'incident a réussi ...',
  GETCAMERABEFOREANDAFTERBYLOCATION_FAIL =
      '[Tunnel Watch] Le chargement des caméra qui precèdent l\'incident a échoué ...',
  GETCAMERABEFOREANDAFTERBYLOCATION_INPROGRESS =
      '[Tunnel Watch] Le chargement des caméra qui precèdent l\'incident est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================



/**
 * Enum pour le chargement de l'ensemble  des incidents
 * @readonly
 * @enum { string }
 */

export enum TunnelWatchCameraLoadedActionTypes {

  /** @type {string} */
  TUNNELWATCHCAMERALOADED_SUCCESS =
      '[Tunnel Watch] Le chargement de l\'ensemble  des incidents du tunnel  a réussi ...',
  TUNNELWATCHCAMERALOADED_FAIL =
      '[Tunnel Watch] Le chargement de l\'ensemble  des incidents du tunnel  a échoué ...',
  TUNNELWATCHCAMERALOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement de l\'ensemble  des incidents du tunnel  est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour le chargement d'une incident
 * @readonly
 * @enum { string }
 */

export enum TunnelWatchOneCameraLoadedActionTypes {

  /** @type {string} */
  TUNNELWATCHONECAMERALOADED_SUCCESS =
      '[Tunnel Watch] Le chargement de l\' incident a réussi ...',
  TUNNELWATCHONECAMERALOADED_FAIL =
      '[Tunnel Watch] Le chargement de l\' incident a échoué ...',
  TUNNELWATCHONECAMERALOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement de l\' incident est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour le chargement de la camera
 * @readonly
 * @enum { string }
 */
export enum CameraByIdLoadedActionTypes {

  /** @type {string} */

  CAMERABYIDLOADED_SUCCESS =
      '[Tunnel Watch] Le chargement de la camera a réussi ...',
  CAMERABYIDLOADED_FAIL =
      '[Tunnel Watch] Le chargement de la camera a échoué ...',
  CAMERABYIDLOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement de la camera est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour la création du simulateur des incidents
 * @readonly
 * @enum { string }
 */
export enum SimulatorActionTypes {

  /** @type {string} */

  SIMULATOR_SUCCESS =
      '[Tunnel Watch] La création du simulateur des incidents  a réussi ...',
  SIMULATOR_FAIL =
      '[Tunnel Watch] La création du simulateur des incidents  a échoué ...',
  SIMULATOR_INPROGRESS =
      '[Tunnel Watch] La création du simulateur des incidents  est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour la création des paramètres du tunnel
 * @readonly
 * @enum { string }
 */
export enum SystemSettingsActionTypes {

  /** @type {string} */

  SYSTEMSETTINGS_SUCCESS =
      '[Tunnel Watch] La création des paramètres du tunnel  a réussi ...',
  SYSTEMSETTINGS_FAIL =
      '[Tunnel Watch] La création des paramètres du tunnel  a échoué ...',
  SYSTEMSETTINGS_INPROGRESS =
      '[Tunnel Watch] La création des paramètres du tunnel  est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour le chargement des paramètres de la section
 * @readonly
 * @enum { string }
 */
export enum SectionSettingsActionTypes {

  /** @type {string} */

  SECTIONSETTINGS_SUCCESS =
      '[Tunnel Watch] Le chargement des paramètres de la section  a réussi ...',
  SECTIONSETTINGS_FAIL =
      '[Tunnel Watch] Le chargement des paramètres de la section  a échoué ...',
  SECTIONSETTINGS_INPROGRESS =
      '[Tunnel Watch] Le chargement des paramètres de la section est en cours ...',
  SECTIONSETTINGS_RESET = '[Tunnel Watch] Initialisation des données ...',
}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour le chargement des zones de la section
 * @readonly
 * @enum { string }
 */
export enum SectionZonesLoadedActionTypes {

  /** @type {string} */

  SECTIONZONESLOADED_SUCCESS =
      '[Tunnel Watch] Le chargement des zones de la section a réussi ...',
  SECTIONZONESLOADED_FAIL =
      '[Tunnel Watch] Le chargement des zones de la section  a échoué ...',
  SECTIONZONESLOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement des zones de la section est en cours ...',
  SECTIONZONESLOADED_RESET =
      '[Tunnel Watch] Initialisation des zones de la section...',


}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour le changement de direction de zone de section
 * @readonly
 * @enum { string }
 */
export enum SectionSaveZoneActionTypes {

  /** @type {string} */

  SECTIONSAVEZONE_SUCCESS =
      '[Tunnel Watch] Le changement de direction de zone de section a réussi ...',
  SECTIONSAVEZONE_FAIL =
      '[Tunnel Watch] Le changement de direction de zone de section  a échoué ...',
  SECTIONSAVEZONE_INPROGRESS =
      '[Tunnel Watch] Le changement de direction de zone de section est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour le changement des paramètres de section
 * @readonly
 * @enum { string }
 */
export enum SetSectionSettingsActionTypes {

  /** @type {string} */

  SETSECTIONSETTINGS_SUCCESS =
      '[Tunnel Watch] Le changement des paramètres de section a réussi ...',
  SETSECTIONSETTINGS_FAIL =
      '[Tunnel Watch] Le changement des paramètres de section  a échoué ...',
  SETSECTIONSETTINGS_INPROGRESS =
      '[Tunnel Watch] Le changement des paramètres de section est en cours ...',
  SETSECTIONSETTINGS_RESET = '[Tunnel Watch] Initialisation des données ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour le chargement de la liste des incidents terminés
 * @readonly
 * @enum { string }
 */
export enum ExploreLoadedActionTypes {

  /** @type {string} */

  EXPLORELOADED_SUCCESS =
      '[Tunnel Watch] Le chargement de la liste des incidents terminés  a réussi ...',
  EXPLORELOADED_FAIL =
      '[Tunnel Watch] Le chargement de la liste des incidents terminés  a échoué ...',
  EXPLORELOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement de la liste des incidents terminés  est en cours ...',
  EXPLORELOADED_RESET =
      '[Tunnel Watch] L\' initialisation de la liste des incidents terminés  a réussi ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour la recherche des incidents par id
 * @readonly
 * @enum { string }
 */
export enum SearchIncidentByIdActionTypes {

  /** @type {string} */

  SEARCHINCIDENTBYID_SUCCESS =
      '[Tunnel Watch] La recherche des incidents par identifant  a réussi ...',
  SEARCHINCIDENTBYID_FAIL =
      '[Tunnel Watch] La recherche des incidents par identifant  a échoué ...',
  SEARCHINCIDENTBYID_INPROGRESS =
      '[Tunnel Watch] La recherche des incidents par identifant  est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour l'extraction de l'incident
 * @readonly
 * @enum { string }
 */

export enum ExploreExtractIncidentActionTypes {

  /** @type {string} */

  EXPLOREEXTRACTINCIDENT_SUCCESS =
      '[Tunnel Watch] L\' extraction de l\'incident  a réussi ...',
  EXPLOREEXTRACTINCIDENT_FAIL =
      '[Tunnel Watch] L\' extraction de l\'incident  a échoué ...',
  EXPLOREEXTRACTINCIDENT_INPROGRESS =
      '[Tunnel Watch] L\' extraction de l\'incident  est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour le chargement de la liste des incidents citilog
 * @readonly
 * @enum { string }
 */

export enum CitilogIncidentLoadedActionTypes {

  /** @type {string} */

  CITILOGINCIDENTLOADED_SUCCESS =
      '[Tunnel Watch] Le chargement de la liste des incidents citilog  a réussi ...',
  CITILOGINCIDENTLOADED_FAIL =
      '[Tunnel Watch] Le chargement de la liste des incidents citilog  a échoué ...',
  CITILOGINCIDENTLOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement de la liste des incidents citilog  est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour l'extraction de l'incident citilog
 * @readonly
 * @enum { string }
 */

export enum CitilogIncidentExtractedActionTypes {

  /** @type {string} */

  CITILOGINCIDENTEXTRACTED_SUCCESS =
      '[Tunnel Watch] L\' extraction de l\'incident citilog  a réussi ...',
  CITILOGINCIDENTEXTRACTED_FAIL =
      '[Tunnel Watch] L\' extraction de l\'incident citilog  a échoué ...',
  CITILOGINCIDENTEXTRACTED_INPROGRESS =
      '[Tunnel Watch] L\' extraction de l\'incident citilog  est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour le chargement de la séquence de la  caméra
 * @readonly
 * @enum { string }
 */

export enum ExploreOneImpactActionTypes {

  /** @type {string} */

  EXPLOREONEIMPACT_SUCCESS =
      '[Tunnel Watch] Le chargement de la séquence de la  caméra  a réussi ...',
  EXPLOREONEIMPACT_FAIL =
      '[Tunnel Watch] Le chargement de la séquence de la  caméra  a échoué ...',
  EXPLOREONEIMPACT_INPROGRESS =
      '[Tunnel Watch] Le chargement de la séquence de la  caméra  est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour le chargement du tableau de bord
 * @readonly
 * @enum { string }
 */
export enum DashboardLoadedActionTypes {

  /** @type {string} */

  DASHBOARDLOADED_SUCCESS =
      '[Tunnel Watch] Le chargement du tableau de bord  a réussi ...',
  DASHBOARDLOADED_FAIL =
      '[Tunnel Watch] Le chargement du tableau de bord  a échoué ...',
  DASHBOARDLOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement du tableau de bord  est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour extraire l'incident sous le format vidéo
 * @readonly
 * @enum { string }
 */
export enum ExtractorVideoActionTypes {

  /** @type {string} */

  EXTRACTORVIDEO_SUCCESS =
      '[Tunnel Watch] L\'extraction de la (des) vidéo(s) a réussi ...',
  EXTRACTORVIDEO_FAIL =
      '[Tunnel Watch] L\'extraction de la (des) vidéo(s) a échoué ...',
  EXTRACTORVIDEO_INPROGRESS =
      '[Tunnel Watch] L\'extraction de la (des) vidéo(s) est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour extraire l'incident au format pdf
 * @readonly
 * @enum { string }
 */

export enum ExtractorPdfIncidentActionTypes {

  /** @type {string} */

  EXTRACTORPDFINCIDENT_SUCCESS =
      '[Tunnel Watch] L\'extraction de l\'incident au format pdf a réussi ...',
  EXTRACTORPDFINCIDENT_FAIL =
      '[Tunnel Watch] L\'extraction de l\'incident au format pdf  a échoué ...',
  EXTRACTORPDFINCIDENT_INPROGRESS =
      '[Tunnel Watch] L\'extraction de l\'incident au format pdf est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour la liste des caméras
 * @readonly
 * @enum { string }
 */

export enum ExtractorCameraListActionTypes {

  /** @type {string} */

  EXTRACTORCAMERALIST_SUCCESS =
      '[Tunnel Watch] L\'extraction de la liste des cameras a réussi ...',
  EXTRACTORCAMERALIST_FAIL =
      '[Tunnel Watch] L\'extraction de la liste des cameras a échoué ...',
  EXTRACTORCAMERALIST_INPROGRESS =
      '[Tunnel Watch] L\'extraction de la liste des cameras est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour la qualification des incidents
 * @readonly
 * @enum { string }
 */

export enum ImpactIsQualifiedActionTypes {

  /** @type {string} */

  IMPACTISQUALIFIED_SUCCESS =
      '[Tunnel Watch] La qualification des incidents a réussi ...',
  IMPACTISQUALIFIED_FAIL =
      '[Tunnel Watch] La qualification des incidents a échoué ...',
  IMPACTISQUALIFIED_INPROGRESS =
      '[Tunnel Watch] La qualification des incidents est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour la suppression de la simulation
 * @readonly
 * @enum { string }
 */
export enum ImpactFakeDeletedActionTypes {

  /** @type {string} */

  IMPACTFAKEDELETED_SUCCESS =
      '[Tunnel Watch] La suppression de la simulation a réussi ...',
  IMPACTFAKEDELETED_FAIL =
      '[Tunnel Watch] La suppression de la simulation a échoué ...',
  IMPACTFAKEDELETED_INPROGRESS =
      '[Tunnel Watch] La suppression de la simulation est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour le chargement de la barre de progression
 * @readonly
 * @enum { string }
 */
export enum ProgressBarActionTypes {

  /** @type {string} */

  PROGRESSBAR_SUCCESS = '[Tunnel Watch] barre de progression  à reussi ',
  PROGRESSBAR_FAIL = '[Tunnel Watch] barre de progression  à échoué ',
  PROGRESSBAR_RESET = '[Tunnel Watch] Remise à zéro de la bar de progression ',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour le chargement du masque par camera
 * @readonly
 * @enum { string }
 */
export enum GetZoneByIdCameraLoadedActionTypes {

  /** @type {string} */

  GETZONEBYIDCAMERALOADED_SUCCESS =
      '[Tunnel Watch] Le chargement du masque par camera et par zone a réussi ...',
  GETZONEBYIDCAMERALOADED_FAIL =
      '[Tunnel Watch] Le chargement du masque par camera et par zone a échoué ...',
  GETZONEBYIDCAMERALOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement du masque par camera et par zone est en cours ...',
  GETZONEBYIDCAMERALOADED_RESET = '[Tunnel Watch] Initialise de la zone ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour le chargement de la totalité des zones
 * @readonly
 * @enum { string }
 */
export enum GetAllZoneForMaskLoadedActionTypes {

  /** @type {string} */

  GETALLZONEFORMASKLOADED_SUCCESS =
      '[Tunnel Watch] Le chargement de la totalité des zones  a réussi ...',
  GETALLZONEFORMASKLOADED_FAIL =
      '[Tunnel Watch] Le chargement de la totalité des zones  a échoué ...',
  GETALLZONEFORMASKLOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement de la totalité des zones  est en cours ...',
  GETALLZONEFORMASKLOADED_RESET = '[Tunnel Watch] Initialisation des zones ...',

}
// ==============================================================================================================
// ==============================================================================================================


/**
 * Enum pour le mouvement de la camera
 * @readonly
 * @enum { string }
 */

export enum MoveCameraActionTypes {

  /** @type {string} */

  MOVECAMERA_TRUE = '[Tunnel Watch] Le camera a bougé a vrai ...',
  MOVECAMERA_FALSE = '[Tunnel Watch] Le camera a bougé a faux ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour le chargement des paramètres d'affichage
 * @readonly
 * @enum { string }
 */

export enum ParametersDisplayLoadedActionTypes {

  /** @type {string} */

  PARAMETERDISPLAYLOADED_SUCCESS =
      '[Tunnel Watch] Le chargement des paramètres d\'affichage  a réussi ...',
  PARAMETERDISPLAYLOADED_FAIL =
      '[Tunnel Watch] Le chargement des paramètres d\'affichage  a échoué ...',
  PARAMETERDISPLAYLOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement des paramètres d\'affichage  est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================


/**
 * Enum pour la mise à jour des paramètres d'affichage
 * @readonly
 * @enum { string }
 */
export enum ParametersDisplayUpdatedActionTypes {

  /** @type {string} */

  PARAMETERDISPLAYUPDATED_SUCCESS =
      '[Tunnel Watch] mise à jour des paramètres d\'affichage  a réussi ...',
  PARAMETERDISPLAYUPDATED_FAIL =
      '[Tunnel Watch] mise à jour des paramètres d\'affichage  a échoué ...',
  PARAMETERDISPLAYUPDATED_INPROGRESS =
      '[Tunnel Watch] mise à jour des paramètres d\'affichage  est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour le chargement des inhibitions globales
 * @readonly
 * @enum { string }
 */

export enum IncidentInhibateGlobalLoadedActionTypes {

  /** @type {string} */

  INCIDENTINHIBATEGLOBALLOADED_SUCCESS =
      '[Tunnel Watch] Le chargement des inhibitions globales a réussi ...',
  INCIDENTINHIBATEGLOBALLOADED_FAIL =
      '[Tunnel Watch] Le chargement des inhibitions globales a échoué ...',
  INCIDENTINHIBATEGLOBALLOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement des inhibitions globales est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour le chargement des inhibitions locales
 * @readonly
 * @enum { string }
 */
export enum IncidentInhibateLocalLoadedActionTypes {

  /** @type {string} */

  INCIDENTINHIBATELOCALLOADED_SUCCESS =
      '[Tunnel Watch] Le chargement des inhibitions locales a réussi ...',
  INCIDENTINHIBATELOCALLOADED_FAIL =
      '[Tunnel Watch] Le chargement des inhibitions locales a échoué ...',
  INCIDENTINHIBATELOCALLOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement des inhibitions locales est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour l'inhibition locale
 * @readonly
 * @enum { string }
 */
export enum IncidentInhibateLocalCreatedActionTypes {

  /** @type {string} */

  INCIDENTINHIBATELOCALCREATED_SUCCESS =
      '[Tunnel Watch] L\'inhibition locale a réussi ...',
  INCIDENTINHIBATELOCALCREATED_FAIL =
      '[Tunnel Watch] L\'inhibition locale a échoué ...',
  INCIDENTINHIBATELOCALCREATED_INPROGRESS =
      '[Tunnel Watch] L\'inhibition locale est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour La suppression d'une inhibition locale
 * @readonly
 * @enum { string }
 */
export enum IncidentInhibateLocalRemoveActionTypes {

  /** @type {string} */

  INCIDENTINHIBATELOCALREMOVE_SUCCESS =
      '[Tunnel Watch] La suppression d\'une inhibition locale a réussi ...',
  INCIDENTINHIBATELOCALREMOVE_FAIL =
      '[Tunnel Watch] La suppression d\'une inhibition locale a échoué ...',
  INCIDENTINHIBATELOCALREMOVE_INPROGRESS =
      '[Tunnel Watch] La suppression d\'une inhibition locale est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour L' extraction du replay de l'incident
 * @readonly
 * @enum { string }
 */

export enum ReplayActionTypes {

  /** @type {string} */

  REPLAY_SUCCESS =
      '[Tunnel Watch] L\' extraction du replay de l\'incident  a réussi ...',
  REPLAY_FAIL =
      '[Tunnel Watch] L\' extraction du replay de l\'incident  a échoué ...',
  REPLAY_INPROGRESS =
      '[Tunnel Watch] L\' extraction du replay de l\'incident  est en cours ...',

}

// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour L' extraction du replay de l'incident
 * @readonly
 * @enum { string }
 */

export enum ReplayDownloadActionTypes {

  /** @type {string} */

  REPLAY_DOWNLOAD_SUCCESS =
      '[Tunnel Watch] Le téléchargement du replay de l\'incident  a réussi ...',
  REPLAY_DOWNLOAD_FAIL =
      '[Tunnel Watch] Le téléchargement du replay de l\'incident  a échoué ...',
  REPLAY_DOWNLOAD_INPROGRESS =
      '[Tunnel Watch] Le téléchargement du replay de l\'incident  est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour le chargement des caméra par point section
 * @readonly
 * @enum { string }
 */

export enum CameraBySectionLoadedActionTypes {

  /** @type {string} */

  CAMERABYSECTIONLOADED_SUCCESS =
      '[Tunnel Watch] Le chargement des caméras par section a réussi ...',
  CAMERABYSECTIONLOADED_FAIL =
      '[Tunnel Watch] Le chargement des caméras par section a échoué ...',
  CAMERABYSECTIONLOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement des caméras par section est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================
/**
 * Enum pour le paramétrage des incidents
 * @readonly
 * @enum { string }
 */

export enum StatsByCameraLoadedActionTypes {

  /** @type {string} */

  STATSBYCAMERALOADED_SUCCESS =
      '[Tunnel Watch] Le chargement des statistiques par caméra pour chaque type d\'incidents a réussi ...',
  STATSBYCAMERALOADED_FAIL =
      '[Tunnel Watch] Le chargement des statistiques par caméra pour chaque type d\'incidents a échoué ...',
  STATSBYCAMERALOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement des statistiques par caméra pour chaque type d\'incidents est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================
/**
 * Enum pour la vérification d'une nouvelle incident
 * @readonly
 * @enum { string }
 */

export enum CheckCameraZoneMaskActionTypes {

  /** @type {string} */

  CHECKCAMERAZONEMASK_SUCCESS =
      'La vérification de l\'existence d\'un masque pour la camera par zone a réussi ...',
  CHECKCAMERAZONEMASK_FAIL =
      'La vérification de l\'existence d\'un masque pour la camera par zone a échoué ...',
  CHECKCAMERAZONEMASK_INPROGRESS =
      'La vérification de l\'existence d\'un masque pour la camera par zone est en cours ...',

}

// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour le chargement de la liste des incidents terminés
 * @readonly
 * @enum { string }
 */
export enum ExportCameraCSVLoadedActionTypes {

  /** @type {string} */

  EXPORTCAMERACSVLOADED_SUCCESS =
      '[Tunnel Watch] Le chargement de la liste des caméra en format csv  a réussi ...',
  EXPORTCAMERACSVLOADED_FAIL =
      '[Tunnel Watch] Le chargement de la liste des caméra en format csv  a échoué ...',
  EXPORTCAMERACSVLOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement de la liste des caméra en format csv  est en cours ...',


}

// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour la recherche des incidents par id
 * @readonly
 * @enum { string }
 */
export enum InhibitionByCameraLoadedActionTypes {

  /** @type {string} */

  INHIBITIONBYCAMERALOADED_SUCCESS =
      '[Tunnel Watch] La recherche des inhibitions par caméras a réussi ...',
  INHIBITIONBYCAMERALOADED_FAIL =
      '[Tunnel Watch] La recherche des inhibitions par caméras a échoué ...',
  INHIBITIONBYCAMERALOADED_INPROGRESS =
      '[Tunnel Watch] La recherche des inhibitions par caméras est en cours ...',

}

// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour le chargement des paramètre sae
 * @readonly
 * @enum { string }
 */
export enum SaeparameterloadedActionTypes {

  /** @type {string} */
  SAEPARAMETERLOADED_SUCCESS =
      '[Tunnel Watch] Le chargement des paramètres sae  a réussi ...',
  SAEPARAMETERLOADED_FAIL =
      '[Tunnel Watch] Le chargement des paramètres sae  a échoué ...',
  SAEPARAMETERLOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement des paramètres sae  est en cours ...',

}
// ==============================================================================================================

/**
 * Enum pour l'envoie des paramètre sae
 * @readonly
 * @enum { string }
 */
export enum SaeparameterActionTypes {

  /** @type {string} */
  SAEPARAMETER_SUCCESS =
      '[Tunnel Watch] L\'envoie des paramètres sae  a réussi ...',
  SAEPARAMETER_FAIL =
      '[Tunnel Watch] L\'envoie des paramètres sae  a échoué ...',
  SAEPARAMETER_INPROGRESS =
      '[Tunnel Watch] L\'envoie des paramètres sae  est en cours ...',

}
// ==============================================================================================================

/**
 * Enum pour l'envoie des paramètre authorisation
 * @readonly
 * @enum { string }
 */
export enum UserAuthorizationLoadActionTypes {

  /** @type {string} */
  USERAUTHORIZATIONLOAD_SUCCESS =
      '[Tunnel Watch] Le chargement des authorisations de l\' utilisateur  a réussi ...',
  USERAUTHORIZATIONLOAD_FAIL =
      '[Tunnel Watch] Le chargement des authorisations de l\' utilisateur  a échoué ...',
  USERAUTHORIZATIONLOAD_INPROGRESS =
      '[Tunnel Watch] Le chargement des authorisations de l\' utilisateur  est en cours ...',

}
/**
 * Enum pour l'envoie des paramètre des rôles
 * @readonly
 * @enum { string }
 */
export enum UserRightLoadActionTypes {

  /** @type {string} */
  USERRIGHTLOAD_SUCCESS =
      '[Tunnel Watch] Le chargement des rôles  a réussi ...',
  USERRIGHTLOAD_FAIL = '[Tunnel Watch] Le chargement des rôles  a échoué ...',
  USERRIGHTLOAD_INPROGRESS =
      '[Tunnel Watch] Le chargement des rôles  est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour la recherche des incidents par id
 * @readonly
 * @enum { string }
 */
export enum LapiAndTmpLoadedActionTypes {

  /** @type {string} */

  LAPIANDTMPLOADED_SUCCESS =
      '[Tunnel Watch] Le chargement des plaques des caminions classés TMD a réussi ...',
  LAPIANDTMPLOADED_FAIL =
      '[Tunnel Watch] Le chargement des plaques des caminions classés TMD a échoué ...',
  LAPIANDTMPLOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement des plaques des caminions classés TMD est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour la recherche des incidents par id
 * @readonly
 * @enum { string }
 */
export enum IncidentstmdLoadedActionTypes {

  /** @type {string} */

  INCIDENTSTMDLOADED_SUCCESS =
      '[Tunnel Watch] Le chargement des incicents classés TMD a réussi ...',
  INCIDENTSTMDLOADED_FAIL =
      '[Tunnel Watch] Le chargement des incicents classés TMD a échoué ...',
  INCIDENTSTMDLOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement des incicents classés TMD est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour la recherche des incidents par id
 * @readonly
 * @enum { string }
 */
export enum CameraLapiTmdLoadedActionTypes {

  /** @type {string} */

  CAMERALAPITMDLOADED_SUCCESS =
      '[Tunnel Watch] Le chargement des caméras lapi et tmd a réussi ...',
  CAMERALAPITMDLOADED_FAIL =
      '[Tunnel Watch] Le chargement des caméras lapi et tmd a échoué ...',
  CAMERALAPITMDLOADED_INPROGRESS =
      '[Tunnel Watch] Le chargement des caméras lapi et tmd est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour la recherche des incidents par id
 * @readonly
 * @enum { string }
 */
export enum ExtrairePdfTmdActionTypes {

  /** @type {string} */

  EXTRAIREPDFTMD_SUCCESS =
      '[Tunnel Watch] L\'extraction du pdf tmd et lapi a réussi ...',
  EXTRAIREPDFTMD_FAIL =
      '[Tunnel Watch] L\'extraction du pdf tmd et lapi a échoué ...',
  EXTRAIREPDFTMD_INPROGRESS =
      '[Tunnel Watch] L\'extraction du pdf tmd et lapi est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour la recherche des incidents par id
 * @readonly
 * @enum { string }
 */
export enum SearchlapiTmdIncidentActionTypes {

  /** @type {string} */

  SEARCHLAPITMDINCIDENT_SUCCESS =
      '[Tunnel Watch] La recherche des incidnets de type lapi et tmd a réussi ...',
  SEARCHLAPITMDINCIDENT_FAIL =
      '[Tunnel Watch] La recherche des incidnets de type lapi et tmd a échoué ...',
  SEARCHLAPITMDINCIDENT_INPROGRESS =
      '[Tunnel Watch] La recherche des incidnets de type lapi et tmd est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour la recherche des incidents par id
 * @readonly
 * @enum { string }
 */
export enum QualificationIncidentTmdActionTypes {

  /** @type {string} */

  QUALIFICATIONINCIDENTTMD_SUCCESS =
      '[Tunnel Watch] La qualification de l\'incident TMD a réussi ...',
  QUALIFICATIONINCIDENTTMD_FAIL =
      '[Tunnel Watch] La qualification de l\'incident TMD a échoué ...',
  QUALIFICATIONINCIDENTTMD_INPROGRESS =
      '[Tunnel Watch] La qualification de l\'incident TMD est en cours ...',

}
// ==============================================================================================================
// ==============================================================================================================

/**
 * Enum pour la recherche des incidents par id
 * @readonly
 * @enum { string }
 */
export enum FilterIncidentTmdActionTypes {

  /** @type {string} */

  FILTERINCIDENTTMD_SUCCESS =
      '[Tunnel Watch] Le triage des incidents TMD a réussi ...',
  FILTERINCIDENTTMD_FAIL =
      '[Tunnel Watch] Le triage des incidents TMD  a échoué ...',
  FILTERINCIDENTTMD_INPROGRESS =
      '[Tunnel Watch] Le triage des incidents TMD  est en cours ...',

}


// WEBPACK FOOTER //
// ./src/apps/tunnel/enums/store/actions/index.ts